<template>
  <v-dialog v-model="showTermAndConditionFormDialog" :max-width="maxWidth">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t("pages.termAndCondition.form.title") }}</span>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-row no-gutters>
            <v-container class="white">
              <span class="input-label">{{ $t('pages.termAndCondition.form.language') }}</span>
              <validated-component
                name="Language"
                v-model="termAndCondition.language"
                :validator="$v.termAndCondition.language"
              >
                <v-select
                  class="field mt-4"
                  outlined
                  hide-details
                  no-filter
                  :items="availableLanguages"
                  v-model="termAndCondition.language"
                  prepend-inner-icon="mdi-translate"
                  append-icon="$icons_system_caret_down"
                ></v-select>
              </validated-component>

              <span class="input-label">{{ $t('pages.termAndCondition.form.type') }}</span>
              <validated-component
                name="Type"
                v-model="termAndCondition.type"
                :validator="$v.termAndCondition.type"
              >
                <v-select
                  class="field mt-4"
                  outlined
                  hide-details
                  no-filter
                  :items="termAndConditionTypes"
                  v-model="termAndCondition.type"
                  append-icon="$icons_system_caret_down"
                ></v-select>
              </validated-component>

              <template v-if="termAndCondition.type === 'FILE_UPLOAD'">
                <validated-component
                  name="File"
                  v-model="termAndCondition.file"
                  :validator="$v.termAndCondition.file"
                >
                  <v-file-input
                    v-model="termAndCondition.file"
                    :label="$t('pages.termAndCondition.form.file')"
                    :placeholder="$t('pages.termAndCondition.form.file')"
                    prepend-inner-icon="mdi-upload"
                    prepend-icon=""
                    hide-details
                    outlined>
                  </v-file-input>
                </validated-component>
              </template>
              <template v-else-if="termAndCondition.type === 'FLEET_URL'">
                <validated-component
                  name="Url"
                  v-model="termAndCondition.url"
                  :validator="$v.termAndCondition.url"
                >
                  <v-text-field
                    v-model="termAndCondition.url"
                    :label="$t('pages.termAndCondition.form.url')"
                    :placeholder="$t('pages.termAndCondition.form.url')"
                    prepend-inner-icon="mdi-link"
                    hide-details
                    outlined/>
                </validated-component>
              </template>

              <div role="alert" :if="error">{{error}}</div>

                <v-alert
                  v-if="uploadingWordFile"
                  outlined
                  dense
                  prominent
                  border="left"
                  type="warning"
                  color="warning">
                  {{ $t('pages.termAndCondition.form.uploadingWordFile') }}
                </v-alert>

            </v-container>
          </v-row>
        </v-container>
      </v-card-text>

    <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="hideTermAndConditionFormDialog">{{
            $t("pages.termAndCondition.form.cancel")
          }}</v-btn>
        <v-btn color="primary" @click="saveTermAndCondition()" :loading="saveLoading" :disabled="disableSubmit">{{
            $t("pages.termAndCondition.form.save")
          }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import * as _ from 'lodash';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    availableLanguages: {
      type: Array,
      required: true,
    },
    showTermAndConditionFormDialog: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    termAndCondition: {
      language: null,
      type: null,
      url: null,
      file: null,
    },
    termAndConditionTypes: [
      { text: 'File Upload', value: 'FILE_UPLOAD' },
      { text: 'URL', value: 'FLEET_URL' },
    ],
    saveLoading: false,
    error: null,
  }),
  methods: {
    resetForm() {
      this.termAndCondition = {
        language: null,
        type: null,
        url: null,
        file: null,
      };

      this.error = null;

      this.$nextTick(() => { this.$v.$reset(); });
    },
    hideTermAndConditionFormDialog() {
      this.$emit('hideTermAndConditionFormDialog');
      this.resetForm();
    },
    async saveTermAndCondition() {
      try {
        this.saveLoading = true;
        const { language, file, type, url } = this.termAndCondition;

        const payload = _.omitBy({ language, type, file, url }, _.isNil);

        const formData = new FormData();
        Object.keys(payload).forEach((key) => {
          formData.append(key, payload[key]);
        });

        const result = await this.$store.dispatch('bookingChannel/createBookingChannelTermAndCondition', {
          bookingChannelId: window.bookingChannelConfig.id,
          payload: formData,
        });

        if (!result.errorCode) {
          this.$emit('saveTermAndCondition', result);
          this.resetForm();
        }
      } finally {
        this.saveLoading = false;
      }
    },
  },
  computed: {
    maxWidth() {
      if (this.isMobile) {
        return '100%';
      }
      return '1200px';
    },
    disableSubmit() {
      return this.$v.$invalid;
    },
    uploadingWordFile() {
      return this.termAndCondition.file && this.termAndCondition.file.name.endsWith('.docx');
    },
  },
  validations() {
    return {
      termAndCondition: {
        language: {
          required,
        },
        type: {
          required,
        },
        file: {
          required: (value) => {
            if (this.termAndCondition.type === 'FILE_UPLOAD') {
              return required(value);
            }
            return true;
          },
          size: (value) => {
            if (value) {
              if (this.termAndCondition.type === 'FILE_UPLOAD') {
                return value.size < 5000000; // 5MB
              }
            }

            return true;
          },
        },
        url: {
          required: (value) => {
            if (this.termAndCondition.type === 'FLEET_URL') {
              return required(value);
            }
            return true;
          },
        },
      },
    };
  },
};
</script>
